import { useQuery } from '@tanstack/react-query'
import React, { useState } from 'react'
import { useNavigate } from 'react-router-dom'

import { orders } from '../../../../api/services/orders'
import {
  OrderChangesHistory,
  OrderExtendedDetails
} from '../../../../api/services/orders/types.ts'
import Button from '../../../common/Button/Button.tsx'
import Card from '../../../common/Card/Card.tsx'
import ChangesHistory from '../ChangesHistory/ChangesHistory.tsx'
import ItemCard from '../ChangesHistory/ItemCard/ItemCard.tsx'
import Planned from '../planned/Planned.tsx'

const FolderAssignment = ({
  order,
  refreshKey
}: {
  order: OrderExtendedDetails
  refreshKey: number
}) => {
  const navigate = useNavigate()
  const [activeTab, setActiveTab] = useState<'Planned' | 'ChangesHistory'>(
    'Planned'
  )
  const [plannedShareDate, setPlannedShareDate] = useState<
    OrderChangesHistory[] | null
  >(null)
  const [onlyHistory, setOnlyHistory] = useState<OrderChangesHistory[]>([])

  if (!order) return null

  const fetchData = async () => {
    const orderHistory = await orders.getOrderChangesHistory(order.id)
    const onlyPlannedFiltered = orderHistory.filter(
      (item) => item.planned_share_date
    )
    const onlyHistoryFiltered = orderHistory.filter(
      (item) => item.planned_share_date === null
    )
    onlyPlannedFiltered.reverse()
    setPlannedShareDate(onlyPlannedFiltered)
    setOnlyHistory(onlyHistoryFiltered)

    return orderHistory
  }
  const { data, isLoading, error } = useQuery({
    queryKey: ['changesHistory', order.id, refreshKey],
    queryFn: fetchData
  })

  if (error instanceof Error) {
    console.error('Error:', error.message)
  }

  return (
    <React.Fragment>
      <Card.Title>
        <div className="h-10 flex flex-row justify-between items-center">
          <span className="mr-3">Przypisane foldery</span>
          {data && data.length > 0 && (
            <Button
              variant="filled"
              size="medium"
              color="primary"
              type="button"
              className="mb-3"
              onClick={() => navigate(`/orders/${order.id}/realization`,
              {
                state: {
                  order
                }
              })}
            >
              {'Zmień folder'}
            </Button>
          )}
        </div>
      </Card.Title>
      <Card.Body>
        {isLoading && <p>Loading...</p>}
        {data && data.length === 0 && <p>Brak przypisanego folderu</p>}
        {plannedShareDate && plannedShareDate.length > 0 && (
          <ItemCard
            key={plannedShareDate[plannedShareDate.length - 1].created_at}
            item={plannedShareDate[plannedShareDate.length - 1]}
          />
        )}

        <div className="flex border-b border-t mt-6">
          <button
            className={`flex-1 p-4 text-center ${
              activeTab === 'Planned'
                ? 'border-b-4 font-bold border-blue-500'
                : ''
            }`}
            onClick={() => setActiveTab('Planned')}
          >
            Udostępnienie diet
          </button>

          <button
            className={`flex-1 p-4 text-center ${
              activeTab === 'ChangesHistory'
                ? 'border-b-4 font-bold border-blue-500'
                : ''
            }`}
            onClick={() => setActiveTab('ChangesHistory')}
          >
            Historia zmian
          </button>
        </div>

        {activeTab === 'Planned' && plannedShareDate && (
          <Planned planned={plannedShareDate} />
        )}
        {activeTab === 'ChangesHistory' && onlyHistory && (
          <ChangesHistory onlyHistory={onlyHistory} />
        )}
      </Card.Body>
    </React.Fragment>
  )
}

export default FolderAssignment
